// extracted by mini-css-extract-plugin
module.exports = {"csvImportInfo":"InvitationListUploader_csvImportInfo_2zaJU"};